<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div *ngIf="openPdfPreviewModal">
    <app-pdf-preview [resourceUrl]="readOnlyFileUrl" [isPdfPreviewModalShow]="openPdfPreviewModal" 
    (showPdfPreviewModal)="showPdfPreviewModal($event)">
    </app-pdf-preview>
  </div>
<div id="quarantineDocumentPanelList" *ngIf="isPanelListDataAvailable">
    <div *ngIf="panelCardViewType == defaultView">
        <app-panel-list [showLoader]="showLoader" [panelList]="quarantinedDocumentsPanelList" [noResultFound]="noData"
            (selectedItems)="getSelectedItems($event)" [ifAdditionalItems]="true"
            [defaultFiltersSelected]="defaultFiltersSelected" [isExportButtonAvailable]="isExportButtonAvailable"
            (panelCardViewTypeEvent)="checkPanelCardViewType($event)" (panelCardViewEvent)="switchPanelCardView()">
            <span class="additional-items">
                <p-checkbox class="col p-0 pr-2" name="showInactive" value="all" *ngIf="isShowCheckbox === true"
                    [(ngModel)]="selectCheckbox" [binary]="true" (onChange)="checkboxSelectionChange()"></p-checkbox>
                <label *ngIf="enableInactiveLabel">
                    {{checkboxLabel}}
                </label>
                <i *ngIf="showInformationIconCheckbox === true" class="fa fa-info-circle ml-2 info-icon-color"
                    aria-hidden="true" pTooltip="{{ informationIconTooltip }}"></i>
            </span>
            <ng-template #templateRef let-data="dataVar">
                <div class="card">
                    <div class="card-container">
                        <div class="flex">
                            <div class="overflow-ellipse flex-initial flex document-header font-semibold">
                                <div *ngIf="data?.phase!= cancelledDocumentPhaseConstant">
                                    <em class="blue-color cursor-pointer"
                                        (click)="downloadFile(data.filePath,data.fileType,data.printLock)">
                                        <em class="fa-solid fa-file fileIconStyle"></em></em>
                                </div>
                                <div pTooltip="{{data.documentNumber}} {{data.title}} (v{{data.version}})">
                                    <span>{{ data?.documentNumber }} {{(data?.title.length>90)?
                                        (data?.title | slice:0:90)+'..':(data?.title)}} (v{{ data?.version }})</span>
                                </div>
                            </div>
                            <div class="documentPhase icon-alignment">
                                <b><i class="pi pi-circle-fill green-button"
                                        [ngClass]="calculatePhaseColor(data.phase)"></i></b> &nbsp;
                                <div class="iconAlignment">
                                    {{displayPhaseLabelWithDate(data?.phase, data.effectiveDate,
                                    data.requestedEffectiveDate)}} {{displayQuarantineStatus(data)}}
                                    &nbsp;
                                </div>
                                <button *ngIf="data?.isFavorite && !enableFavoriteButton" pButton pRipple type="button"
                                    icon="pi pi-star-fill favoriteIconColor"
                                    class="p-button-rounded p-button-text favoriteIconStyle"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #templateRef let-data="dataVar">
                <div class="grid">
                    <div class="col-fixed" style="width: 15%">
                        <div class="font-semibold mb-1">Legacy Document #</div>
                        <div class="content-wrap">
                            {{ data?.legacyDocumentNumber }}
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 12%">
                        <div class="font-semibold mb-1">Next Review Date</div>
                        <div class="content-wrap">
                            {{data?.nextReviewDate | date:'dd-MMM-yyyy'}}
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 16%">
                        <div class="font-semibold mb-1">Sub-BU</div>
                        <div class="content-wrap">
                            {{ data?.responsibleSubBU }}
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 14%">
                        <div class="font-semibold mb-1">Category</div>
                        <div class="content-wrap">
                            {{ data?.category }}<br
                                *ngIf="data?.category !== null && data?.category != undefined && data?.localCategory !== null && data?.localCategory != undefined">{{data?.localCategory}}
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 14%">
                        <div class="font-semibold mb-1">Type</div>
                        <div class="content-wrap">
                            {{ data?.documentType }}<br
                                *ngIf="data?.documentType !== null && data?.documentType != undefined && data?.localType !== null && data?.localType != undefined">{{data?.localType}}
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 10%"
                        *ngIf="data?.queuePanelCardDisplay == displayAssignedAdmin">
                        <div class="font-semibold mb-1">Assigned Admin(s)</div>
                        <div [pTooltip]="calculateToolTip(data?.assignedAdmins)">
                            <div *ngFor="let assignedAdmin of data?.assignedAdmins.slice(0,3)">
                                <div class="content-wrap"
                                    [ngClass]="{'inActiveGroup': assignedAdmin.isActive == false || assignedAdmin.isTerminated===true }">
                                    {{ assignedAdmin.name }}
                                </div>
                            </div>
                            <div *ngIf="data?.assignedAdmins.length > 3"> ...</div>
                        </div>
                    </div>
                    <div class="col-fixed" style="width: 17%">
                        <div class="font-semibold mb-1">eQMS Scope</div>
                        <div class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">
                            {{ scope }}
                        </div>
                    </div>
                </div>
            </ng-template>
        </app-panel-list>
    </div>

    <div class="btnClass" *ngIf="quarantinedDocumentsPanelList?.lists?.length>0">
        <p-button appPreventDoubleClick label="Release from Quarantine" id="endDelegateButton" class="release-button"
            icon="fa-solid fa-circle-check" iconPos="left" [disabled]="isConfirmBtnDisable"
            (debounceClick)="releaseConfirmationDialog()"></p-button>

        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Reject" id="rejectButton"
            class="reject-button" icon="fa fa-xmark" iconPos="left" [disabled]="isConfirmBtnDisable"
            (debounceClick)="rejectConfirmationDialog()"></p-button>
    </div>
</div>

<div *ngIf="isRejectQuarantinedDocumentModal">
    <app-reject-quarantined-document-modal
      (rejectQuarantinedDocuments)="
        rejectDocuments($event)"
      (isRejectQuarantinedDocumentModalVisible)="
        closeRejectQuarantinedDocumentModal()"
    ></app-reject-quarantined-document-modal>
  </div>